// test2339
(2339 && 0);
